// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","317":"34e1de3e","618":"846dd1fe"}[chunkId] + ".css";
};